<template>
    <div>
        <EditorLight />
        <portal-target name="modals" multiple />
        <ToastList />
    </div>
</template>

<script>
import EditorLight from '../../components/EditorLight/EditorLight.vue';
import ToastList from '@speechki-frontend/shared/ui/ToastList';

export default {
    name: 'EditorLightPage',
    components: {
        EditorLight,
        ToastList
    }
};
</script>
